import type { SVGProps } from "react";

const ShieldIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 1.66667L16.6667 4.16667V9.16667C16.6667 13.3333 13.8333 16.6667 10 18.3333C6.16667 16.6667 3.33333 13.3333 3.33333 9.16667V4.16667L10 1.66667Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 9.5V6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="10" cy="12.5" r="0.75" fill="currentColor" />
    </svg>
  );
};

export default ShieldIcon;
